import React from "react";
import { Box, CircularProgress, Paper, Typography } from "@mui/material";
import DataLoadErrorAlert from "components/common/DataLoadErrorAlert";
import SectionCard from "components/dashboard/chartmind/SectionCard";

/**
 * Teaching pearls, laid out like the ChartMind steps around it: centred h4 heading, one line of
 * guidance, then one SectionCard per pearl.
 *
 * Pearls are generated in the background while the encounter is recorded, so on arrival they are
 * usually already here. The spinner is only for the case where the clinician got here first.
 */
const PearlsStep = ({ subject = "", pearls = [], loading = false, error = "", retry }) => (
  <Box sx={{ width: "100%" }}>
    <Box sx={{ textAlign: "center", mb: 4 }}>
      <Typography variant="h4" sx={{ mb: { xs: 1.5, sm: 2 } }}>
        Teaching Pearls
      </Typography>
      <Typography variant="body1" sx={{ color: "text.secondary", lineHeight: 1.6 }}>
        {subject
          ? `Points worth keeping in mind for ${subject}.`
          : "Points worth keeping in mind for this encounter."}
      </Typography>
    </Box>

    {error ? <DataLoadErrorAlert message={error} onRetry={retry} sx={{ width: "100%" }} /> : null}

    {loading && !pearls.length ? (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    ) : null}

    {!loading && !error && !pearls.length ? (
      <Typography variant="body2" color="text.secondary" align="center">
        No pearls for this encounter.
      </Typography>
    ) : null}

    {/* A pearl is one self-contained point, so it gets no heading of its own. A heading only
        appears when the prompt supplies a real one; "Pearl 1, Pearl 2" said nothing. */}
    {pearls.map((pearl) =>
      pearl.title ? (
        <SectionCard key={pearl.id} title={pearl.title} content={pearl.body} maxPreviewLength={2000} />
      ) : (
        <Paper key={pearl.id} variant="outlined" sx={{ p: 2, mb: 2 }}>
          <Typography variant="body1">{pearl.body}</Typography>
        </Paper>
      ),
    )}
  </Box>
);

export default PearlsStep;
